import { RoleGuard } from './modules/core/guard/role.guard';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './modules/core/guard/auth.guard';
import { AdminGuard } from './modules/core/guard/admin.guard';

const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./components/landing/landing.component').then(m => m.LandingComponent),
  },
  {
    path: 'redirect',
    loadComponent: () => import('./components/redirect/redirect.component').then(m => m.RedirectComponent),
  },
  {
    path: 'unauthorized',
    loadComponent: () => import('./components/unauthorized/unauthorized.component').then(m => m.UnauthorizedComponent),
  },

  {
    path: '401',
    loadComponent: () => import('./shared/components/restricted-access/restricted-access.component').then(m => m.RestrictedAccessComponent),
  },
  {
    path: 'mapping/:shortUrl',
    // canActivate: [AuthGuard, RoleGuard],
    loadComponent: () => import('./components/mapping/mapping.component').then(m => m.MappingComponent),
  },
  {
    path: 'case-studies/large-texas-city',
    loadComponent: () => import('./components/case-studies/large-texas-city/large-texas-city.component').then(m => m.LargeTexasCityComponent),
  },
  {
    path: 'case-studies/health-care-landing-zone',
    loadComponent: () => import('./components/case-studies/health-care-landing-zone/health-care-landing-zone.component').then(m => m.HealthCareLandingZoneComponent),
  },
  {
    path: 'case-studies/migration-large-texas-city',
    loadComponent: () => import('./components/case-studies/migration-large-texas-city/migration-large-texas-city.component').then(m => m.MigrationLargeTexasCityComponent),
  },
  {
    path: 'case-studies/migration-large-texas-hospital',
    loadComponent: () => import('./components/case-studies/migration-large-texas-hospital/migration-large-texas-hospital.component').then(m => m.MigrationLargeTexasHospitalComponent),
  },
  {
    path: 'case-studies/migration-large-texas-city-draas',
    loadComponent: () => import('./components/case-studies/migration-large-texas-city-draas/migration-large-texas-city-draas.component').then(m => m.MigrationLargeTexasCityDraasComponent),
  },
  {
    path: 'case-studies/migration-multi-national-financial-organization',
    loadComponent: () => import('./components/case-studies/migration-multi-national-financial-organization/migration-multi-national-financial-organization.component').then(m => m.MigrationMultiNationalFinancialOrganizationComponent),
  },
  {
    path: 'case-studies/digital-workspace-orange-unified-school-district',
    loadComponent: () => import('./components/case-studies/digital-workspace-orange-unified-school-district/digital-workspace-orange-unified-school-district.component').then(m => m.DigitalWorkspaceOrangeUnifiedSchoolDistrictComponent),
  },
  {
    path: 'case-studies/digital-workspace-sundown-isd-and-netsync',
    loadComponent: () => import('./components/case-studies/digital-workspace-sundown-isd-and-netsync/digital-workspace-sundown-isd-and-netsync.component').then(m => m.DigitalWorkspaceSundownISDAndNetsyncComponent),
  },
  {
    path: 'assessment/cloud-readiness-assessment',
    loadComponent: () => import('./components/assessment/cloud-readiness-assessment/cloud-readiness-assessment.component').then(m => m.CloudReadinessAssessmentComponent),
  },
  {
    path: 'assessment/report/:report_id',
    loadComponent: () => import('./components/assessment/cloud-readiness-report/cloud-readiness-report.component').then(m => m.CloudReadinessReportComponent),
  },
  {
    path: 'measure',
    canActivate: [AuthGuard, RoleGuard],
    loadChildren: () =>
      import('./modules/measure/measure.module').then((m) => m.MeasureModule),
  },
  {
    path: 'operate',
    canActivate: [AuthGuard, RoleGuard],
    loadChildren: () =>
      import('./modules/operate/operate.module').then((m) => m.OperateModule),
  },
  {
    path: 'deploy',
    canActivate: [AuthGuard, RoleGuard],
    loadChildren: () =>
      import('./modules/deploy/deploy.module').then((m) => m.DeployModule),
  },
  {
    path: 'migration',
    canActivate: [AuthGuard, RoleGuard],
    loadChildren: () =>
      import('./modules/migration/migration.module').then(
        (m) => m.MigrationModule
      ),
  },
  {
    path: '',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./modules/train/train.module').then((m) => m.TrainModule),
  },
  {
    path: 'tools',
    canActivate: [AuthGuard, AdminGuard],
    loadChildren: () =>
      import('./modules/pricing-tools/pricing-tools.module').then(
        (m) => m.PricingToolsModule
      ),
  },
  {
    path: 'support',
    canActivate: [AuthGuard, RoleGuard],
    loadChildren: () =>
      import('./modules/support/support.module').then((m) => m.SupportModule),
  },
  {
    path: 'profile',
    canActivate: [RoleGuard],
    loadChildren: () =>
      import('./modules/profile/profile.module').then((m) => m.ProfileModule),
  },

  {
    path: '',
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./modules/operate/operate.module').then(
            (m) => m.OperateModule
          ),
      },
    ],
  },

  { path: '**', redirectTo: '404', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
